import React from 'react';
import styled from 'styled-components';
import XIcon from 'assets/icon-x';
import { Portal } from 'components/atoms/Portal';
import { motion, AnimatePresence } from 'framer-motion';

const MotionOverlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: black;
  z-index: var(--way-design-modalZIndex);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  max-width: 100%;
  max-height: 100%;
`;

const GalleryWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 2rem;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 2rem;
  right: 2rem;
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  z-index: 10000;
`;

interface FullScreenImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const FullScreenImageModal = ({
  isOpen,
  onClose,
  children,
}: FullScreenImageModalProps) => {
  return (
    <Portal>
      <AnimatePresence>
        {isOpen && (
          <MotionOverlay
            initial={{ y: '100%', opacity: 0 }}
            animate={{
              y: 0,
              opacity: 1,
              transition: { duration: 0.3, ease: 'easeOut' },
            }}
            exit={{
              y: '100%',
              opacity: 0,
              transition: { duration: 0.3, ease: 'easeIn' },
            }}
          >
            <Content>
              <CloseButton onClick={onClose}>
                <XIcon style={{ width: '32px', height: '32px' }} />
              </CloseButton>
              <GalleryWrapper>{children}</GalleryWrapper>
            </Content>
          </MotionOverlay>
        )}
      </AnimatePresence>
    </Portal>
  );
};

export default FullScreenImageModal;
